// Turkish formatting helpers
const tr = new Intl.NumberFormat("tr-TR");
const trDec = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2, minimumFractionDigits: 2 });

export const money = (n, compact = false) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (compact) {
    if (abs >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(2).replace(".", ",")} Mr TL`;
    if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(".", ",")} Mn TL`;
    if (abs >= 1_000) return `${(n / 1_000).toFixed(0)} B TL`;
    return `${tr.format(Math.round(n))} TL`;
  }
  return `${tr.format(Math.round(n))} TL`;
};

export const moneyExact = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return `${trDec.format(Number(n))} TL`;
};

export const pct = (n, digits = 1) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `%${Number(n).toFixed(digits).replace(".", ",")}`;
};

export const num = (n) => (n === null || n === undefined ? "—" : tr.format(n));

export const growthClass = (n) => (n === null || n === undefined ? "neutral" : n >= 0 ? "positive" : "negative");

export const achievementSeverity = (n) => {
  if (n === null || n === undefined) return "muted";
  if (n >= 100) return "good";
  if (n >= 90) return "warn-soft";
  if (n >= 75) return "warn";
  return "critical";
};

export const shortDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("tr-TR");
  } catch (e) { return iso; }
};

export const PERIODS = [
  { key: "ytd", label: "Yıl Başından Bugüne" },
  { key: "current_month", label: "Bu Ay" },
  { key: "last_month", label: "Geçen Ay" },
  { key: "full_year", label: "Tam Yıl" },
  { key: "custom", label: "Özel Tarih" },
];

// Turkish labels for org node types and target modes
export const NODE_TYPE_TR = {
  REGION: "Bölge",
  GROUP: "Grup",
  SUBGROUP: "Alt Grup",
  CHANNEL: "Kanal",
  TEAM: "Ekip",
  SELLER: "Satıcı",
};

export const TARGET_MODE_TR = {
  NONE: "Hedefsiz",
  CHILD_SUM: "Alt Hedefleri Topla",
  EXPLICIT_TOTAL: "Tanımlı Toplam",
  OWN_PLUS_CHILDREN: "Kendi + Alt Hedefler",
};

export const nodeTypeLabel = (t) => NODE_TYPE_TR[t] || t;
export const targetModeLabel = (t) => TARGET_MODE_TR[t] || t;

export const CUSTOMER_TYPE_TR = {
  CORPORATE: "Kurumsal",
  INDIVIDUAL: "Bireysel",
  UNKNOWN: "İnceleme",
  ALL: "Tümü",
};

export const CUSTOMER_TYPE_SOURCE_TR = {
  CUSTOMER_MASTER: "Müşteri kartı",
  CUSTOMER_MASTER_UNKNOWN: "Müşteri kartı · belirsiz",
};

export const customerTypeLabel = (value) => CUSTOMER_TYPE_TR[value] || value || "—";
export const customerTypeSourceLabel = (value) => CUSTOMER_TYPE_SOURCE_TR[value] || value || "—";

export const isoToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
};
